<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppProgressBar from '@/components/AppProgressBar.vue'

/**
 * How far a player is through the stages of a stage event: one stage per track, and a stage is taken
 * as soon as it is raced (or started, when it is hardcore), so the bar counts the tracks left.
 */
const props = defineProps({
  /** Tracks still to be taken, as the event payload carries them (`stagesLeft`). */
  stagesLeft: { type: Number, required: true },
  /** Tracks of the event: one stage each. */
  total: { type: Number, required: true },
})

const { t } = useI18n()

const played = computed(() => Math.max(0, props.total - props.stagesLeft))
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between ga-2 text-caption text-medium-emphasis mb-1">
      <span>{{ t('events.stagesProgress', { played, total }) }}</span>
      <span v-if="stagesLeft === 1">{{ t('events.stagesLeftOne') }}</span>
      <span v-else-if="stagesLeft">{{ t('events.stagesLeft', { n: stagesLeft }) }}</span>
    </div>

    <AppProgressBar :value="played" :max="total" color="green" />
  </div>
</template>
